import React from "react";
import { CircularProgress } from "@mui/material";
import { GridPreferencePanelsValue, useGridApiContext } from "@mui/x-data-grid";
import {
    SovosBox,
    SovosButton,
    SovosToolbarActions,
    SovosToolbarColumn,
    SovosToolbarFilter,
    SovosToolbarGroup,
    SovosTooltip,
    SovosTypography,
} from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const StagingDataToolbar = ({ toolbarProps, defaultToolbarProps }) => {
    const { i18n } = useGlobalValue();
    const {
        aiDisabledReason,
        aiSuggestionsEnabled,
        isSaving,
        loading,
        onOpenAiPanel,
        onToggleErrors,
        showErrorsDisabled,
        showErrorsOnly,
    } = toolbarProps || {};
    const {
        availableFilters,
        filterArray,
        isFilterPanelOpen,
        isPreferencesPanelOpen,
    } = defaultToolbarProps || {};
    const gridRef = useGridApiContext();

    const toggleColumnPanel = () => {
        if (isPreferencesPanelOpen) {
            gridRef.current.hidePreferences();
        } else {
            gridRef.current.showPreferences(GridPreferencePanelsValue.columns);
        }
    };

    const toggleFilterPanel = () => {
        if (isFilterPanelOpen) {
            gridRef.current.hideFilterPanel();
        } else {
            gridRef.current.showFilterPanel();
        }
    };

    const appliedFiltersCount = (filterArray || []).reduce(
        (count, item) => count + (item?.filters?.length || 0),
        0,
    );

    return (
        <SovosToolbarGroup
            sx={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <SovosTypography variant="body2">
                {i18n`You are validating data format. Fix or proceed with warning`}
            </SovosTypography>
            <SovosToolbarActions>
                <SovosButton
                    size="small"
                    variant={showErrorsOnly ? "contained" : "outlined"}
                    color={showErrorsOnly ? "error" : "primary"}
                    onClick={onToggleErrors}
                    disabled={showErrorsDisabled}
                >
                    {i18n`Show Errors`}
                </SovosButton>
                <SovosTooltip
                    title={aiDisabledReason || i18n`Open Sovi AI fix suggestions`}
                    placement="top"
                >
                    <SovosBox component="span" sx={{ display: "inline-flex", ml: 1 }}>
                        <SovosButton
                            size="small"
                            variant="outlined"
                            disabled={
                                !aiSuggestionsEnabled
                                || !onOpenAiPanel
                                || !!aiDisabledReason
                            }
                            onClick={onOpenAiPanel}
                        >
                            {i18n`Show AI suggestion`}
                        </SovosButton>
                    </SovosBox>
                </SovosTooltip>
                {(loading || isSaving) && (
                    <SovosBox sx={{ alignItems: "center", display: "flex", gap: 0.5 }}>
                        <CircularProgress size={12} />
                        <SovosTypography variant="caption" sx={{ color: "text.secondary" }}>
                            {loading ? i18n`Scanning…` : i18n`Saving…`}
                        </SovosTypography>
                    </SovosBox>
                )}
                <SovosToolbarColumn onClick={toggleColumnPanel} />
                {availableFilters?.length > 0 && (
                    <SovosToolbarFilter
                        appliedFiltersCount={appliedFiltersCount}
                        onClick={toggleFilterPanel}
                    />
                )}
            </SovosToolbarActions>
        </SovosToolbarGroup>
    );
};

export default StagingDataToolbar;
